<script setup>
const props = defineProps({
    filters: { type: Object, required: true },
});

const emit = defineEmits(['create-campaign']);

const filterLabels = {
    job_title: 'Job Title',
    job_title_level: 'Seniority',
    job_title_role: 'Role',
    location: 'Location',
    company_industry: 'Industry',
    company_size: 'Company Size',
    company_summary: 'Keywords',
    skill: 'Skills',
};

const getFilterLabel = (key) => filterLabels[key] || key.replace(/_/g, ' ');

const getDisplayValue = (val) => {
    if (typeof val === 'object' && val !== null) {
        return val.v ? val.v.replace(/"/g, '') : JSON.stringify(val);
    }
    return String(val);
};
</script>

<template>
    <div class="h-full flex flex-col bg-white">
        <div class="p-4 border-b border-gray-200">
            <h3 class="text-sm font-semibold text-gray-900">
                <mf-translate domainkey="lead-hunter:hugo.filtersUsed"></mf-translate>
            </h3>
        </div>

        <div class="flex-1 overflow-y-auto p-4 space-y-4">
            <div v-for="(values, key) in filters" :key="key">
                <p class="text-xs font-medium text-gray-500 mb-1.5">{{ getFilterLabel(key) }}</p>
                <div class="flex flex-wrap gap-1.5">
                    <span
                        v-for="(val, idx) in (Array.isArray(values) ? values : [values])"
                        :key="idx"
                        class="inline-flex items-center px-2.5 py-1 rounded-md text-xs bg-aiAgentLeadFinder/40 text-gray-800 border border-aiAgentLeadFinder"
                    >
                        {{ getDisplayValue(val) }}
                    </span>
                </div>
            </div>
        </div>

        <div class="p-4 border-t border-gray-200">
            <button-primary
                @click="emit('create-campaign')"
                size="lg"
                class="w-full justify-center"
            >
                <mf-translate domainkey="lead-hunter:hugo.createCampaign"></mf-translate>
            </button-primary>
        </div>
    </div>
</template>
